import React from "react";

// components
import Timeout from "core/IllustrativeIcons/Timeout";
import Link from "core/Link";

// styles
import colors from "core/colors";
import { Container, Title, Message, IconContainer } from "./styles";

const UnableToContribute = () => {
    return (
        <Container>
            <Title>Your account is no longer able to contribute.</Title>
            <Message>
                Please see{" "}
                <Link
                    href="https://brand.thenounproject.com/s/What-We-Look-For-Prq1px/?v=0"
                    target="_blank"
                >
                    acceptance tips and guidelines
                </Link>
                .
            </Message>
            <IconContainer>
                <Timeout fillColor={colors.accent.lightMode.pansy} />
            </IconContainer>
        </Container>
    );
};

export default UnableToContribute;
